"use client";
import HeroSection from '@/components/home/HeroSection';
import AboutSection from '@/components/home/AboutSection';
import ServicesSection from '@/components/home/ServicesSection';
import GeminiAnalyzerSection from '@/components/home/GeminiAnalyzerSection';
import ITPackageSection from '@/components/home/ITPackageSection';
import CostCalculatorSection from '@/components/home/CostCalculatorSection';
import WebsitePackagesSection from '@/components/home/WebsitePackagesSection';
import ProductSection from '@/components/home/ProductSection';
import EmergingAISection from '@/components/home/EmergingAISection';
import TechStackSection from '@/components/home/TechStackSection';
import ExperienceSection from '@/components/home/ExperienceSection';
import AchievementsSection from '@/components/home/AchievementsSection';
import EducationSection from '@/components/home/EducationSection';
import ContactSection from '@/components/home/ContactSection';


export default function Home (){
    return (
      <main className="bg-gray-900 text-gray-300 font-sans antialiased">
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <GeminiAnalyzerSection />
        <ITPackageSection />
        <CostCalculatorSection />
        <WebsitePackagesSection />
        <ProductSection />
        <EmergingAISection />
        <TechStackSection />
        <AchievementsSection />
        <ContactSection />
      </main>
    )
}